import { Drawer } from "antd";
import profileUser from "./../../../assets/images/profile-2user.svg";
import shoppingBag from "./../../../assets/images/shopping-bag.svg";
import close from "./../../../assets/images/close.svg";
import dayjs from "dayjs";
import useStore from "../../../store/useStore";

const MonetaryPopup = ({
  monetaryTrend,
  selectedMonetary,
  patientReferred,
  monetaryPopupHandler,
}: any) => {
  const { doctorDetails } = useStore((state) => ({
    doctorDetails: state.doctorDetails,
  }));
  const commission = doctorDetails?.user?.commission || 0;
  const yearMonth = monetaryTrend?.[selectedMonetary]?.month;
  const patientReferredCount = patientReferred?.find(
    (item: any) => item.yearMonth === yearMonth
  )?.count;
  return (
    <Drawer
      placement="bottom"
      onClose={monetaryPopupHandler}
      closeIcon={false}
      open={true}
      height="auto"
      className="rounded-t-2xl overflow-hidden"
    >
      <div className="flex flex-col gap-y-8">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-lg">
            {dayjs(monetaryTrend?.[selectedMonetary]?.month).format("MMMM")}{" "}
            Monetary Trend
          </div>
          <img src={close} alt="close" onClick={monetaryPopupHandler} />
        </div>
        <div className="flex justify-center items-center">
          <div className="w-[200px] h-[200px] bg-[#2D005B] text-white rounded-[200px] flex flex-col justify-end items-center gap-y-6 font-semibold">
            <div>₹{monetaryTrend?.[selectedMonetary]?.planPurchased || 0}</div>

            <div className="w-[100px] h-[100px] bg-[#A8ACFF] text-white rounded-[102px] mb-[2px] flex items-center justify-center font-semibold">
              ₹{monetaryTrend?.[selectedMonetary]?.earnings || 0}
            </div>
          </div>
        </div>
        <div className="flex justify-between">
          <div className="flex items-center">
            <span className="absolute w-[15px] h-[16px] bg-[#2D005B] rounded" />
            <span className="ml-6">Total Value of plan purchased</span>
          </div>
          <span className="font-semibold text-base">
            ₹{monetaryTrend?.[selectedMonetary]?.planPurchased || 0}
          </span>
        </div>
        <div className="flex justify-between">
          <div className="flex items-center">
            <span className="absolute w-[15px] h-[16px] bg-[#A8ACFF] rounded" />
            <span className="ml-6">Total Rewards Earned ({commission}%)</span>
          </div>
          <span className="font-semibold text-base">
            ₹{monetaryTrend?.[selectedMonetary]?.earnings || 0}
          </span>
        </div>
        <div className="flex gap-6">
          <div className="p-4 border border-[#DCE4E8] rounded-2xl flex gap-x-2 items-baseline justify-between bg-white">
            <div className="flex flex-col items-start">
              <img src={profileUser} alt="close" />
              <span className="text-[#5A6774] text-left pb-3 pt-2">
                Total Patients Referred
              </span>
              <span className="font-semibold text-2xl">
                {patientReferredCount || 0}
              </span>
              <span className="text-xs">Patients</span>
            </div>
          </div>
          <div className="p-4 border border-[#DCE4E8] rounded-2xl flex gap-x-2 items-baseline justify-between bg-white">
            <div className="flex flex-col items-start">
              <img src={shoppingBag} alt="close" />
              <span className="text-[#5A6774] text-left pb-3 pt-2">
                Total Plan Purchased
              </span>
              <span className="font-semibold text-2xl">
                {monetaryTrend?.[selectedMonetary]?.count || 0}
              </span>
              <span className="text-xs">Plans</span>
            </div>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default MonetaryPopup;
